<template>
  <div class="teamrewards">
    <toptitle :title1="titlework" />
    <van-tabs>
      <van-tab title="奖励信息">
        <section class="menu">
          <div @click="showPopup"
               class="choosedate">
            {{ dateSearch | datefmt }}
          </div>
          <div style="border-left: 1px solid #e5e5e5;"
               @click="showPopup2"
               class="choosedate">{{ rewardsDept }}</div>

          <div style="border-left: 1px solid #e5e5e5;"
               @click="showPopup4"
               class="choosedate">{{ rewardsType }}</div>

          <div style="border-left: 1px solid #e5e5e5;"
               @click="showPopup3"
               class="choosedate">{{ rewardsCate }}</div>

          <van-popup v-model="show"
                     position="bottom">
            <van-datetime-picker show-toolbar
                                 v-model="dateSearch"
                                 title="选择年份"
                                 type="year"
                                 @confirm="onConfirm"
                                 @cancel="onCancel"
                                 :min-date="MinDate"
                                 :max-date="MaxDate" />
          </van-popup>
          <van-popup v-model="show2"
                     position="bottom">
            <van-picker show-toolbar
                        :columns="columns2"
                        @confirm="onConfirm2"
                        @cancel="onCancel" />
          </van-popup>
          <van-popup v-model="show3"
                     position="bottom">
            <van-picker show-toolbar
                        :columns="columns3"
                        @confirm="onConfirm3"
                        @cancel="onCancel" />
          </van-popup>
          <van-popup v-model="show4"
                     position="bottom">
            <van-picker show-toolbar
                        :columns="columns4"
                        @confirm="onConfirm4"
                        @cancel="onCancel" />
          </van-popup>
        </section>

        <van-empty v-if="emptyreShow"
                   description="暂无奖励信息" />
        <section class="fix"
                 v-for="(item,index) in rewardData"
                 :key="index">
          <div class="fix-divplay">
            <div class="divInfo">
              <p class="divname">{{ item.REWARD_NAME }}</p>
              <p>{{ item.RWD_DATE }}</p>
            </div>
            <!-- <div class="divimg">
              <img class="img-carcle"
                   v-if="item.PHOTO != ''"
                   :src="`data:image/png;base64,${item.PHOTO}`"
                   alt="" />
              <div class="divnameone"
                   v-else>{{ item.NAME | cutName }}</div>
            </div> -->

            <div class="divInfo usermessage">
              <p class="divname">{{ item.NAME }}</p>
              <p>{{ item.POST_DESCR }}</p>
            </div>
            <div class="divInfo">
              <p class="divname">{{ item.REWARD_TYPE }}</p>

            </div>
            <div class="divInfo">
              <p class="divname">{{ item.REWARD_CATEGORY }}</p>

            </div>

          </div>
        </section>

      </van-tab>
      <van-tab title="惩罚信息">
        <section class="menu">
          <div @click="showPopup"
               class="choosedate">
            {{ dateSearch | datefmt }}
          </div>
          <div style="border-left: 1px solid #e5e5e5;"
               @click="showPopup2"
               class="choosedate">{{ rewardsDept }}</div>
          <div style="border-left: 1px solid #e5e5e5;"
               @click="showPopup5"
               class="choosedate">{{ punishCate }}</div>

          <div style="border-left: 1px solid #e5e5e5;"
               @click="showPopup6"
               class="choosedate">{{ punishType }}</div>

          <van-popup v-model="show"
                     position="bottom">
            <van-datetime-picker show-toolbar
                                 v-model="dateSearch"
                                 title="选择年份"
                                 type="year"
                                 @confirm="onConfirm"
                                 @cancel="onCancel"
                                 :min-date="MinDate"
                                 :max-date="MaxDate" />
          </van-popup>
          <van-popup v-model="show2"
                     position="bottom">
            <van-picker show-toolbar
                        :columns="columns2"
                        @confirm="onConfirm2"
                        @cancel="onCancel" />
          </van-popup>
          <van-popup v-model="show5"
                     position="bottom">
            <van-picker show-toolbar
                        :columns="columns5"
                        @confirm="onConfirm5"
                        @cancel="onCancel" />
          </van-popup>
          <van-popup v-model="show6"
                     position="bottom">
            <van-picker show-toolbar
                        :columns="columns6"
                        @confirm="onConfirm6"
                        @cancel="onCancel" />
          </van-popup>
        </section>
        <div>
          <van-empty v-if="emptypnShow"
                     description="暂无惩罚信息" />
          <section class="fix"
                   v-for="(item,index) in punishData"
                   :key="index">
            <div class="fix-divplay">
              <div class="divInfo"
                   style="width:25%;">
                <!-- <p class="divname">{{ item.PNS_CATEPORY }}</p> -->
                <p>{{ item.PNS_DATE }}</p>
              </div>
              <!-- <div class="divimg">
                <img class="img-carcle"
                     v-if="item.PHOTO != ''"
                     :src="`data:image/png;base64,${item.PHOTO}`"
                     alt="" />
                <div class="divnameone"
                     v-else>{{ item.NAME | cutName }}</div>
              </div> -->

              <div class="divInfo usermessage">
                <p class="divname">{{ item.NAME }}</p>
                <p>{{ item.POST_DESCR }}</p>
              </div>

              <div class="divInfo">
                <p class="divname">{{ item.PNS_LEVEL }}</p>

              </div>
              <div class="divInfo">
                <p class="divname">{{ item.PNS_CATEPORY }}</p>

              </div>
              <!-- <div class="divInfo">
                <p class="divname">{{ item.PNS_PRD }}</p>
                <p>{{ item.PNS_FORM }}</p>
              </div> -->

            </div>
          </section>
        </div>

      </van-tab>
    </van-tabs>
    <loading-show :isLoadindShow="loading"></loading-show>
  </div>
</template>

<script>
import toptitle from '../components/toptitle'
import LoadingShow from '../components/loading'
import dateformat from '@/utils/dateformat'
import {
  getMyDeptDataApi,
  changeDataApi,
  getTeamrewardData,
  getTeamPunishData,
} from '../request/api'
export default {
  name: 'teamrp',
  data() {
    return {
      titlework: '奖惩信息',
      active: 0,
      show: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      emptyreShow: false,
      emptypnShow: false,
      loading: false,
      dateSearch: '',
      rewardsDept: '部门',
      rewardsType: '奖励级别',
      rewardsCate: '奖励种类',
      punishCate: '处分级别',
      punishType: '处分种类',
      MinDate: new Date(2010, 1, 1),
      MaxDate: new Date(),
      department: [],
      categoryArr: [],
      rewardtypeArr: [],
      puniLevelArr: [],
      puniTypeArr: [],
      rewardData: [],
      punishData: [],
      columns: [],
      columns2: [],
      columns3: [],
      columns4: [],
      columns5: [],
      columns6: [],
    }
  },
  mounted() {
    this.getDeptList()
  },
  methods: {
    showPopup() {
      this.show = true
    },
    showPopup2() {
      this.show2 = true
    },
    showPopup3() {
      this.show3 = true
    },
    showPopup4() {
      this.show4 = true
    },
    showPopup5() {
      this.show5 = true
    },
    showPopup6() {
      this.show6 = true
    },
    onConfirm(value) {
      this.dateSearch = value
      this.show = false
      this.getTeamReward()
      this.getTeamPunish()
    },
    onConfirm2(value) {
      this.rewardsDept = value
      this.show2 = false
      this.getTeamReward()
      this.getTeamPunish()
    },
    onConfirm3(value) {
      this.rewardsCate = value
      this.show3 = false
      this.getTeamReward()
    },
    onConfirm4(value) {
      this.rewardsType = value
      this.show4 = false
      this.getTeamReward()
    },
    onConfirm5(value) {
      this.punishCate = value
      this.show5 = false
      this.getTeamPunish()
    },
    onConfirm6(value) {
      this.punishType = value
      this.show6 = false
      this.getTeamPunish()
    },
    onCancel() {
      this.show = false
      this.show2 = false
      this.show3 = false
      this.show4 = false
      this.show5 = false
      this.show6 = false
    },

    /**
     * 部门获取
     * **/
    getDeptList() {
      let params = {
        EMPLID: sessionStorage.getItem('EMPLID'),
      }
      getMyDeptDataApi(params).then((res) => {
        if (res.CODE === 200) {
          this.department = res.DATA

          this.columns2 = this.department.map((item) => {
            return item.DEPT_DESCR
          })
          if (this.rewardsDept == '部门') {
            this.rewardsDept = this.department[0].DEPT_DESCR
          }
          this.getTeamReward()
          this.getTeamPunish()
        }
      })
    },
    /**
     * 奖励信息接口
     * **/
    getTeamReward() {
      // let years = new Date(this.dateSearch)
      // let fullYear = years.getFullYear()
      this.loading = true
      //部门ID
      let departId = ''
      let emplid = ''
      this.department.forEach((element) => {
        if (this.rewardsDept == element.DEPT_DESCR) {
          departId = element.DEPTID
          emplid = element.EMPLID
        }
      })
      //奖励类别
      let categoryrew = ''
      this.categoryArr.forEach((element) => {
        if (this.rewardsCate == element.XLADSHORTNAME) {
          categoryrew = element.FIELDVALUE
        }
      })
      //奖励类型
      let typerew = ''
      this.rewardtypeArr.forEach((element) => {
        if (this.rewardsType == element.XLADSHORTNAME) {
          typerew = element.FIELDVALUE
        }
      })
      let params = {
        DEPTID: departId,
        EMPLID: emplid,
        PARTICULAR_YEAR: dateformat('yyyy', this.dateSearch),
        C_REWARD_CATEGORY: categoryrew,
        C_REWARD_TYPE: typerew,
      }
      getTeamrewardData(params).then((res) => {
        if (res.CODE === 200) {
          this.rewardData = res.DATA
          this.rewardData.forEach((item) => {
            item.PHOTO = item.PHOTO.replace(/<br>/g, '')
          })

          if (this.rewardData.length == 0) {
            this.emptyreShow = true
          } else {
            this.emptyreShow = false
          }
          this.loading = false
        }
      })
    },
    /**
     * 团队处分信息接口
     * **/
    getTeamPunish() {
      // let years = new Date(this.dateSearch)
      // let fullYear = years.getFullYear()
      this.loading = true
      //部门ID
      let departId = ''
      let emplid = ''
      this.department.forEach((element) => {
        if (this.rewardsDept == element.DEPT_DESCR) {
          departId = element.DEPTID
          emplid = element.EMPLID
        }
      })
      //处分级别
      let punishlevel = ''
      this.puniLevelArr.forEach((element) => {
        if (this.punishCate == element.XLADSHORTNAME) {
          punishlevel = element.FIELDVALUE
        }
      })
      //处分种类
      let punishtype = ''
      this.puniTypeArr.forEach((element) => {
        if (this.punishType == element.XLADSHORTNAME) {
          punishtype = element.FIELDVALUE
        }
      })
      let params = {
        DEPTID: departId,
        EMPLID: emplid,
        C_PNS_DATE: dateformat('yyyy', this.dateSearch),
        C_PNS_LVL: punishlevel,
        C_PNS_CATEGORY: punishtype,
      }
      getTeamPunishData(params).then((res) => {
        if (res.CODE === 200) {
          this.punishData = res.DATA
          this.punishData.forEach((item) => {
            item.PHOTO = item.PHOTO.replace(/<br>/g, '')
          })

          if (this.punishData.length == 0) {
            this.emptypnShow = true
          } else {
            this.emptypnShow = false
          }
          this.loading = false
        }
      })
    },
  },
  components: {
    toptitle,
    LoadingShow,
  },
  filters: {
    datefmt(val) {
      //格式化日期查询条件的显示内容

      if (!val) return ''
      return dateformat('yyyy年', new Date(val))
    },
    cutName(val) {
      return val.slice(0, 1)
    },
  },

  created() {
    //能选择的最大年份
    this.MaxDate = new Date(dateformat('yyyy-MM-01'))

    //默认为当前月份
    this.dateSearch = new Date(dateformat('yyyy-MM-01'))
    let params3 = { FIELDNAME: 'C_REWARD_CATEGORY' } //奖励类别
    let params4 = { FIELDNAME: 'C_REWARD_TYPE' } //奖励类型
    let params5 = { FIELDNAME: 'C_PNS_LVL' } //处分级别
    let params6 = { FIELDNAME: 'C_PNS_CATEGORY' } //处分种类
    changeDataApi(params3).then((res) => {
      this.categoryArr = res.DATA
      let allSelect = {
        XLADSHORTNAME: '全部',
        FIELDVALUE: '',
      }
      this.categoryArr.unshift(allSelect)
      this.columns3 = this.categoryArr.map((item) => {
        return item.XLADSHORTNAME
      })
    })

    changeDataApi(params4).then((res) => {
      this.rewardtypeArr = res.DATA
      let allSelect = {
        XLADSHORTNAME: '全部',
        FIELDVALUE: '',
      }
      this.rewardtypeArr.unshift(allSelect)
      this.columns4 = this.rewardtypeArr.map((item) => {
        return item.XLADSHORTNAME
      })
    })
    changeDataApi(params5).then((res) => {
      this.puniLevelArr = res.DATA
      let allSelect = {
        XLADSHORTNAME: '全部',
        FIELDVALUE: '',
      }
      this.puniLevelArr.unshift(allSelect)
      this.columns5 = this.puniLevelArr.map((item) => {
        return item.XLADSHORTNAME
      })
    })
    changeDataApi(params6).then((res) => {
      this.puniTypeArr = res.DATA
      let allSelect = {
        XLADSHORTNAME: '全部',
        FIELDVALUE: '',
      }
      this.puniTypeArr.unshift(allSelect)
      this.columns6 = this.puniTypeArr.map((item) => {
        return item.XLADSHORTNAME
      })
    })
  },
}
</script>

<style  lang="less" scoped>
.menu {
  display: flex;
  border-top: 1px solid #e5e5e5;
  div {
    box-shadow: 0;
  }
  .choosedate {
    width: 50%;
    background: white;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #323233;
    font-size: 15px;
    overflow: hidden;
  }
  .choosedate:after {
    display: inline-block;
    content: '';
    position: relative;
    top: 2px;
    margin-left: 3px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: #999;
  }
}

.fix {
  background: white;
  margin: 10px 5px 0;
  padding: 12px 14px;
  color: #8f8f8f;
  line-height: 27px;
  font-size: 14px;

  .fix-divplay {
    display: flex;
    justify-content: space-between;
    border-radius: 10px;
  }
  .fix-top {
    display: flex;
    .approve1 {
      background: #dbefe2;
      color: #4ab16d;
      width: 50px;
      height: 27px;
      text-align: center;
      border-radius: 10px;
    }
    .approve2 {
      background: #d9e5ff;
      color: #427cff;
      width: 50px;
      height: 27px;
      text-align: center;
      border-radius: 10px;
    }
    .approve3 {
      background: #e48e96;
      color: rgb(230, 3, 3);
      width: 50px;
      height: 27px;
      text-align: center;
      border-radius: 10px;
    }
    .number {
      text-align: right;
      flex: 1;
      span {
        color: black;
      }
    }
  }
}
.divnameone {
  margin-top: 0px;
}
.divimg {
  width: 55px;
  height: 55px;
  background: #55a0f8;
  box-sizing: border-box;
  border-radius: 50%;
  text-align: center;
  line-height: 55px;
  font-size: 18px;
  color: white;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    // overflow: hidden;
  }
}
// .divInfo {
//   width: 28%;
// }
.divInfo:nth-child(1) {
  width: 32%;
}
.divInfo:nth-child(2) {
  width: 28%;
}

.usermessage {
  // width: 30%;
  padding-left: 2%;
}
.divname {
  color: #333;
}

.van-empty {
  background: #fff;
  border-top: 1px solid #ccc;
}
</style>